<div class="edit-company-page">
  <div class="page-header">
    <h1>Edit Company</h1>
  </div>

  <!-- Loading State -->
  @if (loading$ | async) {
    <div class="loading-state">
      <ukg-progress-circular></ukg-progress-circular>
      <p>Loading company details...</p>
    </div>
  }

  <!-- Success Message -->
  @if (saveSuccess$ | async) {
    <div class="success-message">
      <p>Successfully updated company</p>
    </div>
  }

  <!-- Error Message -->
  @if (saveError$ | async; as error) {
    <div class="error-message">
      <p>{{ error }}</p>
    </div>
  }

  <!-- Company Form -->
  @if ((loading$ | async) === false && (currentCompany$ | async); as company) {
    <form [formGroup]="companyForm" class="company-form">
      <!-- Readonly Fields -->
      <div class="readonly-fields-grid">
        <!-- AR Number (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="arNumberLabel">AR Number</span>
          <span class="field-value" aria-labelledby="arNumberLabel">
            {{ company.arNumber || '—' }}
          </span>
        </div>

        <!-- Company Name (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="companyNameLabel">Company Name</span>
          <span class="field-value" aria-labelledby="companyNameLabel">
            {{ company.name || '—' }}
          </span>
        </div>

        <!-- Customer Type (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="customerTypeLabel">Customer Type</span>
          <span class="field-value" aria-labelledby="customerTypeLabel">
            {{ selectedCustomerType || '—' }}
          </span>
        </div>

        <!-- Subprocessor Consent (Read-only) -->
        <div class="form-field read-only">
          <span class="field-label" id="subprocessorConsentLabel"
            >Subprocessor Consent</span
          >
          <span class="field-value" aria-labelledby="subprocessorConsentLabel">
            {{ company.outsourceConsent ? 'Yes' : 'No' }}
          </span>
        </div>
      </div>

      <!-- Shared Company Form Fields -->
      <app-company-form
        [companyForm]="companyForm"
        [printSites$]="printSites$"
        [customerTypes$]="customerTypes$"
        [saving$]="saving$"
        [saveError$]="saveError$"
        [showResetButton]="false"
        [hideCustomerType]="true"
        submitButtonText="Save Changes"
        savingButtonText="Saving..."
        (save)="onSave()"
        (cancel)="onCancel()">
      </app-company-form>
    </form>
  }

  <!-- Error State (No Company Found) -->
  @if (
    (loading$ | async) === false &&
      (currentCompany$ | async) === null &&
      (error$ | async);
    as error
  ) {
    <div class="error-state">
      <p>{{ error }}</p>
      <ukg-button
        variant="primary"
        (click)="onCancel()"
        (keydown.enter)="onCancel()">
        Back to Company List
      </ukg-button>
    </div>
  }
</div>
